// Export all SVG icons from a single file for easy importing

export { default as AmericaLogo } from './AmericaLogo';
export { default as ChinaLogo } from './ChinaLogo';
export { default as DeepCenterLogo } from './DeepcenterLogo';
export { default as OpenAILogo } from './OpenAILogo';
export { default as WorldLogo } from './WorldLogo';
export type { IconProps } from './IconTypes';